import { v4 } from "uuid";

import type {
  ComponentType,
  ModInsertType,
} from "@intelligems/ig-types/schemas/visual-builder/mod-schemas";
import type { EmbeddedInsertPosition } from "@intelligems/ig-types/schemas/plugin/plugin/embedded";
import { createAsyncThunk } from "@src/store";
import { componentDefaults } from "@src/store/slices/experienceBuilder/component/defaults";
import { componentSlice } from "@src/store/slices/experienceBuilder/component/slice";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

const uiPositionToInsertType = (
  position: EmbeddedInsertPosition
): ModInsertType => {
  if (position === "before") {
    return "beforebegin";
  }
  if (position === "after") {
    return "afterend";
  }
  return "replace";
};

export const selectType = createAsyncThunk<void, ComponentType>(
  "experienceBuilder/component/selectType",
  (componentType, { dispatch, getState }) => {
    const state = getState();
    const insertContext = componentSlice.selectors.getInsertContext(state);
    if (!insertContext) {
      return;
    }

    const variationId = experienceBuilderSlice.selectors.getVariationId(state);
    const draft = componentDefaults[componentType]({
      id: v4(),
      variationId,
      selector: insertContext.selector,
      insertType: uiPositionToInsertType(insertContext.position),
      createdAtUrl:
        experienceBuilderSlice.selectors.getLocation(state) ?? undefined,
    });

    dispatch(componentSlice.actions._initDraft(draft));
  }
);
